import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import {
	isDefaultRovoChat,
	trimToUndefined,
} from '@atlassian/conversation-assistant-utils/default-agent';

import { normalizeIdentityValue } from './normalizeIdentityValue';
import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const deriveResponseAuthorIdentity = (
	storeAssistant: StoreAssistant,
): ResponseAuthorIdentity => {
	const message = storeAssistant.content.message.message;
	const backendAgentId = trimToUndefined(message.agent_author?.id);
	const authorId = trimToUndefined(message.author?.id);
	const authorNamedId = trimToUndefined(
		message.author?.external_config_reference ?? message.author?.named_id,
	);

	if (
		isDefaultRovoChat({ agentId: backendAgentId }) ||
		(backendAgentId === undefined && isDefaultRovoChat({ agentId: authorId }))
	) {
		return { isDefault: true };
	}

	// The backend agent author is authoritative when present. Treat the value as a
	// single routing token so a specialist UUID cannot be combined with a legacy
	// default named id from the display author.
	if (backendAgentId) {
		return { id: backendAgentId, isDefault: false };
	}

	const namedId = normalizeIdentityValue(authorNamedId);

	return {
		namedId,
		isDefault: !namedId,
	};
};
